'use strict'

const u = require('universalify').fromCallback
module.exports = {
  copy: u(require('./copy'))
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-extra/lib/copy/index.js
// module id = 344
// module chunks = 0